const helloAndGoodbye = {
  roleplayId: "nualang.hello-goodbye.0.0.1",
  roleplayName: "Bonjour et au revoir",
  description: "Apprenez à dire bonjour et au revoir",
  difficulty: "ALL",
  learnLang: "french",
  picture: "",
  actor1: {
    name: "Lea",
    voice: "Lea",
    picture:
      "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwMi5wbmcifQ==",
  },
  actor2: {
    name: "Claude",
    voice: "Claude",
    picture:
      "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwMS5wbmcifQ==",
  },
  script: [
    { text: "Salut. Comment allez-vous ?", actor: 1 },
    {
      text: "Je vais bien. Merci d'avoir posé la question. Comment vas-tu ?",
      actor: 2,
    },
    { text: "Je ne peux pas me plaindre, la vie me traite bien.", actor: 1 },
    { text: "Ça fait plaisir à entendre.", actor: 2 },
    {
      text: "Content de vous revoir, je dois me rendre à mon rendez-vous chez le médecin.",
      actor: 1,
    },
    { text: "C'est bien de te voir.", actor: 2 },
    { text: "Au revoir", actor: 1 },
  ],
};

export default helloAndGoodbye;
